import {
  Button,
  ControlGroup,
  FormGroup,
  NumericInput,
} from "@blueprintjs/core";
import _ from "lodash";
import { QuantityScale } from "../../../api/types";
import { UserLanguage } from "../../../lang/lang";
import { FormItemBuilder } from "../Form";

export const valid_number_keys = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  ".",
  ",",
  "Backspace",
  "Enter",
  "Tab",
];

export const QuantityScaleBuilder: FormItemBuilder = (bundle) => {
  let payload: QuantityScale = [];

  if (bundle.field_current_value && _.isArray(bundle.field_current_value)) {
    payload = bundle.field_current_value;
  }

  // payload = _.sortBy(payload, ["quantity"], ["asc"]);

  const update_quantity = (index: number, quantity: number) => {
    console.log("update_quantity", index, quantity);
    if (payload[index]) payload[index].quantity = quantity;
    console.log("payload", payload);
    bundle.update_value(payload);
  };

  const update_price = (index: number, price: number) => {
    console.log("update_price", index, price);
    if (payload[index]) payload[index].price = price;
    console.log("payload", payload);
    bundle.update_value(payload);
  };

  const remove_row = (index: number) => {
    bundle.update_value(payload.filter((__, i) => i !== index));
  };

  const rows = [];
  _.forEach(payload, (item, index) =>
    rows.push(
      <ControlGroup
        key={bundle.field_index + "_" + index}
        style={{ marginBottom: 10 }}
      >
        <NumericInput
          fill
          placeholder={UserLanguage().data.quantity_scale.quantity}
          onValueChange={(a) => update_quantity(index, a)}
          value={item.quantity}
          leftIcon="full-stacked-chart"
          allowNumericCharactersOnly={true}
          minorStepSize={1}
          stepSize={10}
          majorStepSize={100}
        />
        <NumericInput
          placeholder={UserLanguage().data.quantity_scale.price}
          allowNumericCharactersOnly={false}
          asyncControl
          minorStepSize={0.0001}
          onBlur={(e) => {
            try {
              const n = parseFloat(
                (e.target as HTMLInputElement).value.split(",").join(".")
              );
              update_price(index, n);
            } catch {}
          }}
          onKeyDown={(e) => {
            const value = (e.target as HTMLInputElement).value;
            if (
              (e.key === "." || e.key === ",") &&
              (_.indexOf(value, ".") !== -1 || _.indexOf(value, ",") !== -1)
            )
              e.preventDefault();

            if (_.indexOf(valid_number_keys, e.key) === -1) {
              e.preventDefault();
              return;
            }
            if (e.key === "Enter" || e.key === "Tab") {
              try {
                const n = parseFloat(
                  (e.target as HTMLInputElement).value.split(",").join(".")
                );
                update_price(index, n);
              } catch {}
            }
          }}
          value={item.price.toFixed(4)}
          leftIcon="euro"
        />
        <Button
          icon="cross"
          intent="danger"
          onClick={() => remove_row(index)}
        />
      </ControlGroup>
    )
  );

  rows.push(
    <Button
      key={bundle.field_index + "_add"}
      onClick={() =>
        bundle.update_value(
          _.cloneDeep(payload).concat([{ price: 1, quantity: 10 }])
        )
      }
      icon="add"
      intent="primary"
    />
  );

  return (
    <FormGroup
      label={bundle.field_properties.label}
      key={bundle.field_index}
      style={{ marginBottom: 10 }}
    >
      {rows}
    </FormGroup>
  );
};
